<template>
  <div class="unlock-login">
    <div v-if="!isPhone" class="login-container">
      <div class="login-img">
        <img :style="this.$store.getters.isPii?{width:'73%'}:{width: '80%'}" :src="this.$store.getters.isPii?require('@/assets/login/pc_img_logo_content_paycools.png'):require('@/assets/login/pc_img_logo_content_unlock.png')" alt="">
      </div>
      <div class="login-form-container">
        <!-- 设计风格国家下拉（仿设计图） -->
        <div v-if="$store.getters.isID && !$store.getters.isMX" class="login-country-wrapper">
          <el-dropdown trigger="click" @command="handleCountrySelect" class="country-dropdown">
            <div class="country-display styled" tabindex="0">
              <span class="country-globe">🌐</span>
              <span class="country-name">{{ getCountryName(selectedCountry) }}</span>
              <i class="el-icon-arrow-down icon-arrow-down-small"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="styled-country-menu">
              <el-dropdown-item
                v-for="item in countries"
                :key="item.code"
                :command="item.code"
                class="styled-country-item"
              >
                <span class="item-name">{{ item.name }}</span>
                <span v-if="item.code === selectedCountry" class="item-check">✔</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="top">
          <div class="title-container">
            <h3 class="title">Login to Merchant Dashboard</h3>
          </div>

          <el-form-item prop="email" label="Email" class="login-form-item">
            <el-input
              ref="email"
              v-model="loginForm.email"
              class="login-input"
              placeholder="Email"
              name="email"
              type="text"
              tabindex="1"
              auto-complete="on"
              size="default"
            />
          </el-form-item>

          <el-form-item prop="password" label="Password" class="login-form-item">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              class="login-input"
              :type="passwordType"
              placeholder="Password"
              name="password"
              tabindex="2"
              auto-complete="on"
              size="default"
              @keyup.enter.native="handleLogin"
            />
            <span class="show-pwd" @click="showPwd">
              <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
            </span>
            <!--            <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>-->
          </el-form-item>

          <el-form-item v-if="show_mfa_flag" prop="verify_code">
            <el-input
              ref="verify_code"
              v-model="loginForm.verify_code"
              class="login-input"
              style="margin: 10px 0"
              placeholder="MFA Verification Code"
              oninput="value=value.replace(/[^\d]/g,'')"
              @keyup.enter.native="handleLogin"
            />
          </el-form-item>

          <!-- <el-form-item v-if="getGoogleVerify()" prop="otp" style="width: 306px" required>
                  <google-login-verify
                    v-model="loginForm.otp"
                    :is-binding-mfa="is_binding_mfa"
                    @getValidateCode="getValidateCode"
                  />
                </el-form-item> -->
          <el-form-item>
            <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>
          </el-form-item>

          <el-button :loading="loading" type="info" size="default" style="width:100%;margin-bottom:30px;font-weight:600" @click.native.prevent="handleLogin">Login</el-button>
          <!-- Register now - 使用 Element UI 链接并导航 -->
          <el-link v-if="$store.getters.isID && !$store.getters.isMX" class="register-now" type="primary" @click="goRegister">Register now</el-link>
        </el-form>
        <p v-if="$store.getters.isPii" class="version-text">© {{ new Date().getFullYear() }} PayCools (Payment Innovations Inc.)</p>
      </div>

    </div>
    <div v-if="isPhone" class="xs-login-container">
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="xs-login-form" auto-complete="on" label-position="top">
        <div class="title-container">
          <h3 class="xs-title">Login to Merchant Dashboard</h3>
        </div>

        <el-form-item prop="email" label="Email">
          <el-input
            ref="email"
            v-model="loginForm.email"
            class="login-input"
            placeholder="Email"
            name="email"
            type="text"
            tabindex="1"
            auto-complete="on"
            size="default"
          />
        </el-form-item>

        <el-form-item prop="password" label="Password" class="form-item-password">
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            class="login-input"
            :type="passwordType"
            placeholder="Password"
            name="password"
            tabindex="2"
            auto-complete="on"
            size="default"
            @keyup.enter.native="handleLogin"
          />
          <span class="show-pwd" @click="showPwd">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span>
          <!--          <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>-->
        </el-form-item>

        <el-form-item v-if="show_mfa_flag" prop="verify_code">
          <el-input
            ref="verify_code"
            v-model="loginForm.verify_code"
            class="login-input"
            style="margin: 10px 0"
            placeholder="MFA Verification Code"
            oninput="value=value.replace(/[^\d]/g,'')"
          />
        </el-form-item>

        <!-- <el-form-item v-if="getGoogleVerify()" prop="otp" style="width: 306px" required>
          <google-login-verify
            v-model="loginForm.otp"
            :is-binding-mfa="is_binding_mfa"
            @getValidateCode="getValidateCode"
          />
        </el-form-item> -->
        <el-form-item>
          <div class="forgot-password" @click="$router.push('/forgotPassword')">Forgot your password?</div>
        </el-form-item>

        <el-button :loading="loading" type="info" size="default" style="width: 100%;font-weight:600" @click.native.prevent="handleLogin">Login</el-button>
        <el-link v-if="$store.getters.isID && !$store.getters.isMX" class="register-now xs" type="primary" @click.prevent="goRegister">Register now</el-link>
      </el-form>
      <p v-if="$store.getters.isPii" class="xs-version-text">© {{ new Date().getFullYear() }} PayCools (Payment Innovations Inc.)</p>
    </div>

    <binding-mfa-modal
      ref="bindingMFAModal"
      :is-binding-mfa="is_binding_mfa"
      :qr_code_base64="qr_code_base64"
      :secret_key="secret_key"
      @verify-code-login="verifyCodeLogin"
    />
  </div>
</template>

<script>
import { sendDeviceVerifyCode, verifyDeviceEmailCode } from '@/api/user'
import { getDeviceHeader, getLocalStorageVal, removeLocalStorageVal, setLocalStorageKeyVal } from '@/utils/helper'
import { cryptoJSAesEncrypt } from '@/utils/encrypt'
import * as Sentry from '@sentry/vue'
import { captureException, reportError } from '@/utils/sentryConfig'

export default {
  name: 'Login',
  components: {
    BindingMfaModal: () => import('@/views/paycools/login/components/Modal/BindingMFAModal'),
    GoogleLoginVerify: () => import('@/views/components/GoogleLoginVerify')
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (value.length <= 0) {
        return callback(new Error('Please enter the user name'))
      }
      return callback()
    }
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('The password can not be less than 8 ~ 15 digits'))
      }
      if (value.length < 6 || value.length > 15) {
        return callback(new Error('The password can not be less than 8 ~ 15 digits'))
      }
      return callback()
    }
    const validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please finish Google Verify'))
      }
      return callback()
    }
    const validateEmailCode = (rule, value, callback) => {
      if (this.checkEmailCodeFlag && !value) {
        return callback(new Error('Please input Email Verification Code'))
      }
      return callback()
    }
    const validateVerifyCode = (rule, value, callback) => {
      if (this.checkEmailCodeFlag && !value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.length < 6 || value.length > 6) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    this.MFA_STATUS = {
      open: 1,
      close: 2
    }
    return {
      loginForm: {
        email: '',
        password: '',
        emailCode: '',
        verify_code: '',
        otp: ''
      },
      loginRules: {
        email: [
          // { type: 'email', message: 'Please input the correct email', required: false, trigger: ['blur', 'change'] }
        ],
        // password: [{ required: false, trigger: 'blur', validator: validatePassword }],
        otp: [{ required: true, trigger: 'blur', validator: validateCode }],
        emailCode: [{ validator: validateEmailCode, trigger: ['blur', 'change'] }],
        verify_code: [{ validator: validateVerifyCode, trigger: ['blur', 'change'] }]
      },
      loading: false,
      passwordType: 'password',
      show_mfa_flag: false,
      deviceSecond: 60,
      deviceSecondFlag: !!getLocalStorageVal('device_second'),
      checkEmailCodeFlag: false,
      redirect: undefined,
      is_binding_mfa: true,
      qr_code_base64: '',
      secret_key: '',
      isPhone: false
    }
  },
  created() {
    // default countries for login selector (placeholder links)
    this.countries = [
      { code: 'MY', name: 'Malaysia', flag: '🇲🇾', link: process.env.NODE_ENV === 'production' ? 'https://merchant.paycools.com.my/' : 'https://nettest.upay365.xyz:8388/' },
      { code: 'ID', name: 'Indonesia', flag: '🇮🇩', link: process.env.NODE_ENV === 'production' ? 'https://mchboard-id.paycools.com/' : 'https://nettest.upay365.xyz:6010/' }
      // { code: 'MX', name: 'Mexico', flag: '🇲🇽', link: '/' },
      // { code: 'BR', name: 'Brazil', flag: '🇧🇷', link: '/' }
    ]
    // default selected from system current country if available
    const sysCode = this.$store && this.$store.getters && this.$store.getters.curCountry && this.$store.getters.curCountry.country_code
    this.selectedCountry = sysCode && this.countries.find(item => item.code === sysCode) ? sysCode : 'ID'
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    const storageSecond = getLocalStorageVal('device_second') ? getLocalStorageVal('device_second') : 60
    this.deviceSecond = storageSecond < 0 ? 60 : storageSecond
    this.deviceSecondFlag = storageSecond >= 0 && storageSecond < 60
    if (this.deviceSecond < 60) {
      this.secretInterval()
    }
    window.onresize = () => {
      this.changePage()
    }
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    changePage() {
      const screenWidth = document.documentElement.clientWidth
      if (screenWidth <= 768) {
        this.isPhone = true
      } else {
        this.isPhone = false
      }
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    getCountryName(code) {
      const item = this.countries && this.countries.find(item => item.code === code)
      return item ? item.name : ''
    },
    getCountryFlag(code) {
      const item = this.countries && this.countries.find(item => item.code === code)
      return item ? item.flag : ''
    },
    handleCountrySelect(code) {
      // set selected and navigate to placeholder link (replace later)
      this.selectedCountry = code
      const country = this.countries.find(item => item.code === code)
      const target = country && country.link ? country.link : '/'
      // use router if internal, otherwise location.href
      if (target.startsWith('/')) {
        this.$router.push(target)
      } else {
        window.location.href = target
      }
    },
    getValidateCode(value) {
      this.loginForm.otp = value
    },
    syncAutofilledFields() {
      const domEmail = this.$refs.email?.$el?.querySelector('input')?.value?.trim()
      if (domEmail && domEmail !== this.loginForm.email) {
        this.loginForm.email = domEmail
      }
      const domPassword = this.$refs.password?.$el?.querySelector('input')?.value?.trim()
      if (domPassword && domPassword !== this.loginForm.password) {
        this.loginForm.password = domPassword
      }
    },
    handleLogin() {
      // 模拟错误触发 Sentry 上报
      // try {
      //   // 故意抛出一个错误，用于测试 Sentry 上报
      //   throw new Error("Test Sentry integration error 20251016 marchant one")
      // } catch (error) {
      //   console.log(error)
      //   captureException(error)
      // }
      this.syncAutofilledFields()
      this.login()
      // if (this.loginForm.verify_code || (this.show_mfa_flag && !this.loginForm.verify_code)) {
      //   this.login()
      // } else {
      //   this.checkSameDevice()
      // }
    },
    checkSameDevice() {
      // if (this.validateLogin()) {
      //   const params = {
      //     email: cryptoJSAesEncrypt(this.loginForm.email),
      //     password: cryptoJSAesEncrypt(this.loginForm.password)
      //   }
      //   checkDevice(params).then(res => {
      //     if (res.code === 10000) {
      //       this.show_mfa_flag = res.data.is_diff
      //       this.is_binding_mfa = true
      //       if (res.data.is_binding_mfa) {
      //         this.is_binding_mfa = false
      //         this.qr_code_base64 = res.data.qr_code_base64
      //         this.secret_key = res.data.secret_key
      //         this.$refs.bindingMFAModal.changModalStatus(true)
      //       }
      //       if (!this.show_mfa_flag) {
      this.login()
      //       } else {
      //         this.checkEmailCodeFlag = true
      //       }
      //     }
      //   })
      // }
    },
    checkSameDeviceEmailCode() {
      this.checkEmailCodeFlag = true
      if (this.validateLogin()) {
        const params = {
          email: cryptoJSAesEncrypt(this.loginForm.email),
          auth_code: this.loginForm.emailCode
        }
        verifyDeviceEmailCode(params).then(res => {
          if (res.code === 10000) {
            if (res.data.status) {
              removeLocalStorageVal('device_second')
              this.login()
            } else {
              const remain_send_num = res.data.remain_verify_num
              this.$message.error('Verification code Error.And you can try ' + remain_send_num + ' more times ')
            }
          }
        })
      }
    },
    submitReSendCode() {
      this.deviceSecondFlag = true
      this.checkEmailCodeFlag = false
      if (this.validateLogin()) {
        this.secretInterval()
        const params = {
          email: cryptoJSAesEncrypt(this.loginForm.email)
        }
        sendDeviceVerifyCode(params).then(res => {
          if (res.code === 10000) {
            const remain_send_num = res.data.remain_send_num
            this.$message.success(`Successful! And you can send verification code for ${remain_send_num} times`)
          }
        })
      } else {
        this.deviceSecondFlag = false
      }
    },
    secretInterval() {
      const that = this
      const secretInterval = setInterval(function() {
        that.deviceSecondFlag = true
        that.deviceSecond--
        setLocalStorageKeyVal('device_second', that.deviceSecond)
        if (that.deviceSecond <= 0) {
          that.deviceSecondFlag = false
          that.deviceSecond = 60
          clearInterval(secretInterval)
        }
      }, 1000)
    },
    verifyCodeLogin(value) {
      this.loginForm.verify_code = value.verify_code
      this.loginForm.otp = value.google_code ? value.google_code : this.loginForm.otp
      this.login()
    },
    login() {
      if (this.validateLogin()) {
        this.loading = true
        const aesKey = this.$commonFn.generateRandomString()
        const aesIV = this.$commonFn.generateRandomString()
        const { email, password, otp, emailCode, verify_code, mch_counterparty } = this.loginForm

        const params = { username: email.trim(), password: password, otp: otp, auth_code: emailCode, verify_code: verify_code, timestamp: Date.now(), device: getDeviceHeader(), mch_counterparty, source: 2 }

        if (this.$store.getters.isEz || this.$store.getters.isAruxpay) {
          params.mch_counterparty = 'unlock'
        } else {
          params.mch_counterparty = 'paycools'
        }

        const paramsData = {}
        const aesKeyIv = JSON.stringify({ key: aesKey, iv: aesIV })
        paramsData.key = this.$commonFn.rsaEncrypt(aesKeyIv)
        paramsData.param = this.$commonFn.cryptoJSAesEncrypt(JSON.stringify(params), aesKey, aesIV)
        paramsData.sign = this.$commonFn.rsaSign(JSON.stringify(params))
        this.$store.dispatch('user/login', paramsData).then((data) => {
          if (!data.token) {
            if (data.mfa_enable === this.MFA_STATUS['open']) {
              this.is_binding_mfa = data.is_binding_mfa
              this.show_mfa_flag = data.show_mfa_flag
              if (!data.is_binding_mfa) {
                this.qr_code_base64 = data.qr_code_base64
                this.secret_key = data.secret_key
                this.$refs.bindingMFAModal.changModalStatus(true)
              }
            }
            return
          }
          this.$router.push({ path: this.redirect || '/' })
        }).finally(() => {
          this.loading = false
        })
      }
    },
    validateLogin() {
      let flag = false
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          flag = true
        }
      })
      return flag
    },
    getGoogleVerify() {
      return true
    },
    goRegister() {
      this.$router.push('/register')
    }
  }
}
</script>
<style>
.unlock-login  input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset !important;
   -webkit-text-fill-color: #4B5567 !important;
}
.unlock-login .login-input .el-input__inner{
  height: 42px;
  border: 1px solid #D2D8E3;
  font-size: 16px;
  border-radius: 8px;
}
.unlock-login .login-form-item .el-form-item__label{
  font-size: 18px;
}
.unlock-login .xs-login-container .google-login-verify{
  /* width: 250px; */
  overflow-y: hidden;
  overflow-x: auto;
}

@media screen and (max-width: 1441px) {
  .unlock-login .login-form-item .el-form-item__label{
    font-size: 16px;
  }
  .unlock-login .login-input .el-input__inner{
    height: 38px;
    font-size: 13px;
  }
}
</style>

<style lang="scss" scoped>
.unlock-login{
  height: 100vh;
}
.login-container {
  height: 100vh;
  width: 100%;
  // background: #FFFFFF;
  overflow: hidden;
  display: flex;
  .login-img{
    // padding-top: 60px;
    width: 50%;
    // min-height: 650px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: linear-gradient(98.94deg, #349EFF 0%, #306EDE 50.7%, #0124D9 100%);
    box-shadow: inset 0px 4px 20px rgba(0, 0, 0, 0.1), inset 0px 4px 10px rgba(0, 0, 0, 0.25);
    &::before{
      content: '';
      position: absolute;
      top: -12.5vw;
      left: -12.5vw;
      transform: rotate(-45deg);
      width: 25vw;
      height: 25vw;
      background: linear-gradient(-45deg, rgba(255, 255, 255, .15) 0, rgba(255, 255, 255, 0) 50%);
    }
    &::after{
      content: '';
      position: absolute;
      bottom:-12.5vw;
      right: -12.5vw;
      transform: rotate(-45deg);
      width: 25vw;
      height: 25vw;
      background: linear-gradient(-45deg, rgba(255, 255, 255, .15) 0, rgba(255, 255, 255, 0) 100%);
    }
     .login-img-content{
       width: 80%;
     }
  }
  .login-form-container{
    position: relative;
    height: 100vh;
    // min-height: 650px;
    flex: 1;
    display: flex;
    justify-content:center;
    align-items: center;
    overflow: hidden;
    .forgot-password{
      text-align: right;
      color: rgba(54, 60, 74, 0.5);
      font-weight: 500;
      font-size: 16px;
      float: right;
      cursor: pointer;
    }
    /* 仅样式 - 登录页右上角国家展示（无逻辑） */
    .login-country-wrapper{
      position: absolute;
      top: 24px;
      right: 40px;
      z-index: 60;
      display: inline-block;
      font-size: 14px;
    }
    .country-display{
      background: #fff;
      border: 2px solid #3B82F6;
      padding: 10px 14px;
      border-radius: 8px;
      color: #1D4ED8;
      box-shadow: none;
      display: flex;
      align-items: center;
      gap: 10px;
      min-width: 180px;
      font-weight: 600;
    }
    .country-display.styled .country-globe{ font-size:18px; margin-right:6px; }
    .country-display .country-name{ display:inline-flex; align-items:center; gap:8px; color:#1D4ED8; }
    .country-display .country-flag{ margin-left:4px; }
    .icon-arrow-down-small{ font-size: 12px; color:#1E293B; margin-left:auto;}
    .styled-country-menu{
      padding: 6px 0;
      border-radius:8px;
      box-shadow: 0 8px 20px rgba(16,24,40,0.08);
      min-width:200px;
    }
    .styled-country-item{
      display:flex !important;
      align-items:center;
      gap:12px;
      padding:12px 16px !important;
      font-size:15px;
      color:#334155;
      cursor:pointer !important;
    }
    .styled-country-item:hover{
      background:#F1F7FF !important;
    }
    .styled-country-item .item-flag{ width:28px; text-align:left; }
    .styled-country-item .item-name{ flex:1; }
    .styled-country-item .item-check{ color:#2563EB; font-weight:700; }

    /* 仅样式 - Register now 外观（无逻辑） */
    .register-now{
      margin-top: 8px;
      text-align: center;
      color: #3579FF;
      cursor: pointer;
      font-weight: 500;
      text-decoration: underline;
    }
    .register-now.xs{
      margin-top: 12px;
      text-align: center;
      color: #3579FF;
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .login-form {
    width: 80%;
    max-width: 520px;
    background: #FFFFFF;
  }
  .title{
    color: #1D3A71;
    font-size: 28px;
  }
  .version-text{
    position: absolute;
    bottom: 25px;
    font-weight: 400;
    font-size: 12px;
    color: #98A1B4;;
  }
}

</style>

<style lang="scss" scoped>

.xs-login-container{
  position: relative;
  padding: 0 36px;
  height: 100vh;
  display: flex;
  justify-content:center;
  align-items: center;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  background: linear-gradient(167.94deg, #142D5A 0%, #1E3885 26.68%, #2742A9 64.82%, #3855F1 100%);
  overflow: hidden;
  &::before{
    content: '';
    position: absolute;
    top:-100px;
    left: -200px;
    transform: rotate(-45deg);
    width: 400px;
    height: 200px;
    background: linear-gradient(180deg, rgba(255, 255, 255, .1) 0, rgba(255, 255, 255, .05) 100%);
  }
  &::after{
    content: '';
    position: absolute;
    bottom:-100px;
    right: -200px;
    transform: rotate(-45deg);
    width: 400px;
    height: 200px;
    background: linear-gradient(180deg, rgba(255, 255, 255, .1) 0, rgba(255, 255, 255, .05) 100%);
  }
  .forgot-password{
    text-align: right;
    color: rgba(54, 60, 74, 0.5);
    font-weight: 500;
    font-size: 16px;
    float: right;
    cursor: pointer;
  }
}

.xs-login-form {
  box-sizing: border-box;
  padding: 59px 32px;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 5px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
}
.form-item-password{
  position: relative;
}
.show-pwd{
  position: absolute;
  right: 13px;
  top: 3px;
  cursor: pointer;
}
.xs-title{
  margin:0;
  font-weight: 700;  font-family: 'Inter-Bold';
  font-size: 16px;
  line-height: 22px;
  color: #1D3A71;
}
.xs-version-text{
  position: absolute;
  bottom: 25px;
  font-weight: 400;
  font-size: 12px;
  color: #FFFFFF;
}

@media screen and (max-width: 1441px) {
 .login-container{
  .title{
      font-size: 22px;
    }
  .login-form {
    width: 60%;
    background: #FFFFFF;
  }
  .show-pwd{
    top: 1px;
  }
 }

}
</style>
